'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useCallback } from 'react';

export default function Sidebar() {
  const pathname = usePathname();
  const isActive = (path: string) => pathname === path || pathname.startsWith(path + '/');

  const closeSidebarOnMobile = useCallback(() => {
    if (typeof window !== 'undefined' && window.innerWidth < 992) {
      document.body.classList.remove('sidebar-open');
      document.body.classList.add('sidebar-collapse');
    }
  }, []);

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      {/* Brand */}
      <Link href="/" className="brand-link" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{
          width: 34, height: 34, borderRadius: 8,
          background: 'linear-gradient(135deg,#4e9af1,#2d7fe0)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
        }}>
          <i className="fas fa-layer-group" style={{ color: '#fff', fontSize: 15 }} />
        </div>
        <span className="brand-text font-weight-light">
          Permit<span>Vault</span>
        </span>
      </Link>

      {/* Sidebar content */}
      <div className="sidebar">
        <nav className="mt-2">
          <ul
            className="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            {/* MAIN */}
            <li className="nav-header">MAIN</li>

            <li className="nav-item">
              <Link href="/" className={`nav-link ${pathname === '/' ? 'active' : ''}`} onClick={closeSidebarOnMobile}>
                <i className="nav-icon fas fa-tachometer-alt" />
                <p>Dashboard</p>
              </Link>
            </li>

            <li className="nav-item">
              <Link href="/sites" className={`nav-link ${isActive('/sites') ? 'active' : ''}`} onClick={closeSidebarOnMobile}>
                <i className="nav-icon fas fa-map-marker-alt" />
                <p>Sites</p>
              </Link>
            </li>

            {/* DATA & LOGS */}
            <li className="nav-header">DATA &amp; LOGS</li>

            <li className="nav-item">
              <Link href="/tables" className={`nav-link ${isActive('/tables') ? 'active' : ''}`} onClick={closeSidebarOnMobile}>
                <i className="nav-icon fas fa-table" />
                <p>Tables</p>
              </Link>
            </li>

            <li className="nav-item">
              <Link href="/cells" className={`nav-link ${isActive('/cells') ? 'active' : ''}`} onClick={closeSidebarOnMobile}>
                <i className="nav-icon fas fa-th" />
                <p>Cells</p>
              </Link>
            </li>

            <li className="nav-item">
              <Link href="/vectors" className={`nav-link ${isActive('/vectors') ? 'active' : ''}`} onClick={closeSidebarOnMobile}>
                <i className="nav-icon fas fa-database" />
                <p>Vector Store</p>
              </Link>
            </li>

            <li className="nav-item">
              <Link href="/logs" className={`nav-link ${isActive('/logs') ? 'active' : ''}`} onClick={closeSidebarOnMobile}>
                <i className="nav-icon fas fa-clipboard-list" />
                <p>Audit Logs</p>
              </Link>
            </li>

            <li className="nav-item">
              <Link href="/costs" className={`nav-link ${isActive('/costs') ? 'active' : ''}`} onClick={closeSidebarOnMobile}>
                <i className="nav-icon fas fa-dollar-sign" />
                <p>Cost Tracking</p>
              </Link>
            </li>

            <li className="nav-item">
              <Link href="/feedback" className={`nav-link ${isActive('/feedback') ? 'active' : ''}`} onClick={closeSidebarOnMobile}>
                <i className="nav-icon fas fa-comments" />
                <p>Feedback</p>
              </Link>
            </li>

            {/* ARCHITECTURE */}
            <li className="nav-header">ARCHITECTURE</li>

            <li className="nav-item">
              <Link href="/architecture" className={`nav-link ${isActive('/architecture') ? 'active' : ''}`} onClick={closeSidebarOnMobile}>
                <i className="nav-icon fas fa-project-diagram" />
                <p>Flow</p>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
}
